import { hotTopics } from "@/mocks/blog";

export default function HotTopics() {
  const scrollToArticles = () => {
    document.getElementById("articles")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="hot" className="bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mb-8 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-accent-600">HOT TOPICS</p>
            <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
              今日热榜 · <span className="text-primary-600">我在围观这些瓜</span>
            </h2>
          </div>
          <button
            onClick={scrollToArticles}
            className="inline-flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700"
          >
            看我的完整解读 <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </button>
        </div>

        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {hotTopics.map((topic) => (
            <article
              key={topic.rank}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-shadow hover:shadow-[0_8px_24px_oklch(var(--background-300)/0.35)]"
            >
              <div className="flex items-center gap-3">
                <span
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full font-display text-sm font-bold ${
                    topic.rank <= 3
                      ? "bg-primary-500 text-background-50"
                      : "bg-secondary-100 text-secondary-700"
                  }`}
                >
                  {topic.rank}
                </span>
                <span className="rounded-full bg-background-100 px-2.5 py-0.5 text-xs font-medium text-foreground-600">
                  {topic.tag}
                </span>
                <span
                  className={`ml-auto flex items-center gap-1 text-xs font-semibold ${
                    topic.trend === "up" ? "text-primary-600" : "text-accent-600"
                  }`}
                >
                  <i
                    className={`${topic.trend === "up" ? "ri-arrow-up-line" : "ri-arrow-down-line"}`}
                    aria-hidden="true"
                  ></i>
                  {topic.heat}°
                </span>
              </div>

              <h3 className="mt-4 font-display text-base font-bold leading-snug text-foreground-950 md:text-lg">
                {topic.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                <i className="mr-1 text-primary-400" aria-hidden="true"></i>
                {topic.take}
              </p>
              <button
                onClick={scrollToArticles}
                className="mt-4 inline-flex cursor-pointer items-center gap-1 self-start text-sm font-semibold text-primary-600 hover:text-primary-700"
              >
                聊聊我的看法 <i className="ri-chat-3-line" aria-hidden="true"></i>
              </button>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}